import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UpaService, UpaTrackingData } from "../../services/upa.service";
import { ScrollService } from "../../services/scroll.service";
import { UtilsService } from 'projects/common/services/utils.service';

@Component({
  selector: 'optional-link',
  template: `

    <ng-container [ngSwitch]="containerType">

      <ng-container *ngSwitchCase="'link'">
        <a [href]="link" [attr.rel]="noFollow ? 'nofollow' : null"
         [attr.target]="(target !== null) ? target : (newTab ? '_blank' : null)"
         [attr.aria-label]="utils.linkToName(link)"
         class="link-container">
          <ng-container *ngTemplateOutlet="justContent"></ng-container>
        </a>
      </ng-container>

      <ng-container *ngSwitchCase="'scroll'">
        <div class="link-container cursor-pointer">
          <ng-container *ngTemplateOutlet="justContent"></ng-container>
        </div>
      </ng-container>

      <ng-container *ngSwitchDefault>
          <ng-container *ngTemplateOutlet="justContent"></ng-container>
      </ng-container>
    </ng-container>


    <ng-template #justContent>
      <span class="optional-link-wrapper" (click)="clickHandler($event)">
        <ng-content></ng-content>
      </span>
    </ng-template>
  `,
  styleUrls: ['./optional-link.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OptionalLinkComponent implements OnInit {

  @Input() link?: string;
  @Input() scrollTarget?: string;
  @Input() noFollow: boolean = false;
  @Input() newTab: boolean = false;
  @Input() target?: string;
  @Input() overrideClickHandler?: any;
  @Input() upaTrackingData: UpaTrackingData;
  containerType: 'link' | 'scroll' | 'default' = 'default';
  clickHandler: any

  constructor(private upaService: UpaService, public utils: UtilsService) { }

  ngOnInit(): void {
    this.containerType = this.link ? 'link' : this.scrollTarget ? 'scroll' : 'default';
    this.clickHandler = this.overrideClickHandler || this.defaultClickHandler;
  }

  defaultClickHandler() {
    if (this.link || this.scrollTarget) {
      this.upaService.trackClickTopic(this.upaTrackingData);

      if (this.scrollTarget != null) {
        ScrollService.scrollTo(this.scrollTarget);
      }
    }
  }
}
